<template>
  <div>
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
      <search></search>
      <banner :bannerInfo="bannerInfo"></banner>
      <shopCategory :cateList="cateList" v-show="cateList.length > 0"></shopCategory>
      <!-- <hotBuy></hotBuy>
        <groupFriend></groupFriend> -->

      <advertising :advertisingInfo="advertisingInfo" v-if="advertisingInfo.is_show"></advertising>

      <productList :productlist="list">精选推荐</productList>
      <copyright></copyright>
    </van-pull-refresh>
  </div>
</template>
<script>
import { banner, shopCategory, advertising } from './components'
import search from '@/components/search'
import copyright from '@/components/copyright'
import productList from '@/components/productList'
import { goodsList, adinfo, getCategory } from '@/api/goods'
import scroll from '@/mixins/scroll'

import { PullRefresh } from 'vant';

export default {
  name: 'Home',
  beforeRouteLeave (to, from, next) {
    this.scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    next();
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.$nextTick(() => {
        window.scrollTo(0, vm.scrollTop)
      })
    })
  },
  components: {
    search,
    banner,
    shopCategory,
    copyright,
    // hotBuy,
    // groupFriend,
    productList,
    advertising,
    [PullRefresh.name]: PullRefresh
  },
  data () {
    return {
      list: [],
      bannerInfo: [],
      cateList: [],
      advertisingInfo: {},
      isLoading: false,
    }
  },
  mixins: [scroll],
  methods: {
    // 获取商品列表
    async getList () {
      const result = await goodsList({
        page: this.page,
        size: 10
      })
      try {
        if (result.data.data.goodsList.data.length !== 0) {
          this.list = this.list.concat(result.data.data.goodsList.data)
        } else {
          this.page = null
        }
      } catch (err) { }

    },
    onRefresh () {
      this.page = 0
      this.list = []
      this.bannerInfo = []
      this.cateList = [],
        this.advertisingInfo = {}
      this.getList()
      this.getAdinfo()
      this.getCate()
      this.isLoading = false
    },
    async getAdinfo () {
      const result = await adinfo()
      try {
        result.data.data.ad_info.map(value => {
          if (value.position_id == 9) {
            this.bannerInfo.push(value)
          }
          if (value.position_id == 10) {
            this.advertisingInfo = value;
          }

        })
      } catch (err) { }

    },
    async getCate () {
      const result = await goodsList({
        page: 1,
        size: 20,
        first_cat_id: 5246
      })
      try {
        this.cateList = result.data.data.goodsList.data
        this.$forceUpdate()
      } catch (err) {

      }
    }
  },
  created () {
    this.getAdinfo()
    this.getCate()
  },
  activated () {
    this.$watch('$route', (to, form) => {
      if (form.name === 'Login' || to.name === 'Login') {
        this.onRefresh()
      }
    })
  }
}
</script>
<style lang="scss" scoped>
body,
html {
  padding-bottom: 2rem;
  background: #f6f6f6;
  padding-top: env(safe-area-inset-top);
  padding-left: env(safe-area-inset-left);
  padding-right: env(safe-area-inset-right);
  padding-bottom: env(safe-area-inset-bottom);
}
</style>
